import React from 'react';
import { Button } from '@/Components/ui/button';
import { Separator } from '@/Components/ui/separator';
import { cn } from '@/lib/utils';

function SocialLogin() {
  return (
    <div className="space-y-4">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <Separator />
        </div>
        <div className="relative flex justify-center text-xs">
          <span className="bg-card px-2 text-muted-foreground">Or continue with</span>
        </div>
      </div>
      
      <div className="flex items-center justify-center gap-3">
        <Button
          type="button"
          variant="outline"
          size="icon"
          className={cn(
            "h-10 w-10 rounded-md",
            "border-border hover:bg-accent hover:border-primary/20",
            "transition-all duration-200 shadow-sm hover:shadow"
          )}
          aria-label="Sign in with Google"
        >
          <img 
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/6eeaec7c748b8433b38763a968e69e291265f3958f03f5ff89e87bcfae61a444?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
            alt="Google"
            className="w-5 h-5"
          />
        </Button>
        
        <Button
          type="button"
          variant="outline"
          size="icon"
          className={cn(
            "h-10 w-10 rounded-md",
            "border-border hover:bg-accent hover:border-primary/20",
            "transition-all duration-200 shadow-sm hover:shadow"
          )}
          aria-label="Sign in with LinkedIn"
        >
          <img 
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/c0b949139a9ddf4f4f5ac6973d797b4430236df90e6f8ec8343a8b4273129caa?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
            alt="LinkedIn"
            className="w-5 h-5"
          />
        </Button>
      </div>
    </div>
  );
}

export default SocialLogin;